export default {"src":"/_next/static/media/facebook-logo.0b5ca352.svg","height":40,"width":40};